
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine } from "@common/src/utils/common";
import SettingMini from "./component/mini-setting.vue";
const store = namespace("store");
const user = namespace("user");
const app = namespace("app");
@Component({
  components: {
    SettingMini
  }
})
export default class StoreInfo extends Vue {
  @store.State storeData;
  @user.State selectedOrgCode;
  @app.State country;
  emptyToLine = emptyToLine;
  get name() {
    return (this.storeData.managerFirstName || "") + (this.storeData.managerLastName || "");
  }
  get address() {
    return (
      (this.storeData.stateName || "") +
      (this.storeData.cityName || "") +
      (this.storeData.districtName || "") +
      (this.storeData.address1 || "")
    );
  }
}
